import { RouteRecord } from "@/router/route";

// format routes data
export const getMenuList = (menus: RouteRecord[] = [], routeList:RouteRecord[] = []) => {
  menus.forEach(item => {
    if(item.children && item.children.length > 0){
      if(!item.meta.hide) getMenuList(item.children, routeList)
    } else {
      routeList.push(item)
    }
  })
  return routeList
}